module.exports = {"522732001":"三合街道","522732111":"大河镇","522732112":"普安镇","522732113":"都江镇","522732114":"中和镇","522732115":"周覃镇","522732116":"九阡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522732.json
// module id = 2349
// module chunks = 0